import React, { useState } from "react";
import Footer from "./Footer";
import "../css/shop.scss";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";
import Header from "./Header";

function Shop() {
  const [selectedFilter, setSelectedFilter] = useState("all");
  const [showMore, setShowMore] = useState(false);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // Filter products based on category
  const getFilteredProducts = () => {
    switch (selectedFilter) {
      case "necklaces":
        return productData.filter((p) => p.category === "Necklaces");
      case "bracelets":
        return productData.filter((p) => p.category === "Bracelets");
      case "earrings":
        return productData.filter((p) => p.category === "Earrings");
      case "rings":
        return productData.filter((p) => p.category === "Rings");
      case "accessories":
        return productData.filter((p) => p.category === "Accessories");
      default:
        return productData;
    }
  };

  const filteredProducts = getFilteredProducts();

  return (
    <div className="prestige--v4 features--heading-small features--heading-uppercase template-index">
      <div className="PageContainer">
        <Header />

        <main className="shop-main">
          {/* Breadcrumb */}
          <div className="breadcrumb">
            <Link to="/">Home</Link>
            <span> / </span>
            <span>New Arrivals</span>
          </div>

          {/* Page Header */}
          <div className="shop-header">
            <h1>New Arrivals</h1>
            <p className="shop-description">
              There's nothing better than something new. Shop our assortment of
              just-landed arrivals, including ca...
              {!showMore && (
                <button className="more-link" onClick={() => setShowMore(true)}>
                  ...more
                </button>
              )}
              {showMore && (
                <>
                  sual everyday essentials, statement pieces, and personalized
                  gifts.
                  <button
                    className="less-link"
                    onClick={() => setShowMore(false)}
                  >
                    {" "}
                    less
                  </button>
                </>
              )}
            </p>
          </div>

          {/* Category Filter Buttons */}
          <div className="filter-buttons">
            <button
              className={selectedFilter === "all" ? "active" : ""}
              onClick={() => setSelectedFilter("all")}
            >
              Shop All New Arrivals
            </button>
            <button
              className={selectedFilter === "necklaces" ? "active" : ""}
              onClick={() => setSelectedFilter("necklaces")}
            >
              New Necklaces
            </button>
            <button
              className={selectedFilter === "bracelets" ? "active" : ""}
              onClick={() => setSelectedFilter("bracelets")}
            >
              New Bracelets
            </button>
            <button
              className={selectedFilter === "earrings" ? "active" : ""}
              onClick={() => setSelectedFilter("earrings")}
            >
              New Earrings
            </button>
            <button
              className={selectedFilter === "rings" ? "active" : ""}
              onClick={() => setSelectedFilter("rings")}
            >
              New Rings
            </button>
            <button
              className={selectedFilter === "accessories" ? "active" : ""}
              onClick={() => setSelectedFilter("accessories")}
            >
              New Accessories
            </button>
          </div>

          {/* Sort & Filter */}
          <div className="sort-filter-bar">
            <span className="filter-label">Sort & Filter</span>
            <span className="filter-option">Product Type</span>
            <span className="filter-option">Metal</span>
            <span className="filter-option">Customizable</span>
            <span className="style-count">
              {filteredProducts.length} Styles
            </span>
          </div>

          {/* Product Grid */}
          <div className="product-grid">
            {filteredProducts.map((product) => (
              <Link
                to={`/shopDetails/${product.id}`}
                key={product.id}
                className="product-card"
                onClick={toTop}
              >
                <div className="product-image-wrapper">
                  <img
                    src={product.images[0]}
                    alt={product.name}
                    className="product-image"
                  />
                  {product.discount && (
                    <div className="discount-badge">
                      {product.discount}% Off Custom Gifts: The Annual Custom
                      Event
                    </div>
                  )}
                </div>
                <div className="product-info">
                  <h3 className="product-name">{product.name}</h3>
                  <p className="product-price">${product.price}</p>
                </div>
              </Link>
            ))}
          </div>
        </main>

        <Footer />
      </div>
    </div>
  );
}

export default Shop;
